import { supabase, getCurrentUser } from '../lib/supabaseClient';
import { apiPost } from '../lib/apiClient';

export interface UserEntityAssignment {
  id: string;
  entity_id: string;
  entity_name: string;
  is_primary: boolean;
}

/**
 * Fetch all entity assignments for a given user, including entity names.
 */
export const getUserEntities = async (userId: string): Promise<UserEntityAssignment[]> => {
  try {
    const { data, error } = await supabase
      .from('user_entities')
      .select('id, entity_id, is_primary, entities(name)')
      .eq('user_id', userId);

    if (error) {
      console.error('Error fetching user entities:', error);
      return [];
    }

    return (data || []).map((row: any) => ({
      id: row.id,
      entity_id: row.entity_id,
      entity_name: row.entities?.name || 'Unknown',
      is_primary: row.is_primary,
    }));
  } catch (error) {
    console.error('Error in getUserEntities:', error);
    return [];
  }
};

/**
 * Fetch the current authenticated user's entity assignments.
 */
export const getMyEntities = async (): Promise<UserEntityAssignment[]> => {
  try {
    const user = await getCurrentUser();
    if (!user) return [];
    return getUserEntities(user.id);
  } catch (error) {
    console.error('Error in getMyEntities:', error);
    return [];
  }
};

/**
 * Switch the current user's active entity.
 * Routes through the API backend (service role) to bypass RLS restrictions
 * on updating users.entity_id.
 */
export const switchActiveEntity = async (entityId: string): Promise<boolean> => {
  try {
    await apiPost('/api/switch-entity', { entityId });
    return true;
  } catch (error) {
    console.error('Error switching active entity:', error);
    return false;
  }
};
